import Vue from 'vue'
import App from '@/App.vue'

import store from '@/store' 
import router from '@/router'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.css' //TODO: production .min.

import Vuetify from 'vuetify'
Vue.use(Vuetify); 


Vue.config.productionTip = false

// Vue.use(VueRouter)

const vue = new Vue({
  router,
  store,
  render: h => h(App)
})

vue.$mount('#app')
